import React from 'react'
import p from 'prop-types'
import styles from './TripRouteEmbed.scss'
import embedStyles from '../embed.scss'
import fetchJSON from 'lib/fetchJSON'
import { Map } from 'common/Map'
import { deserializeTrip, deserializeRoute } from 'lib/api/records'
import cx from 'classnames'
import { formatDistance } from 'lib/units'
import { PhotoClusters } from 'common/Maplet/PhotoClusters'

import TitleBar from '../TitleBar'

export class TripRouteEmbed extends React.PureComponent {
  static propTypes = {
    id: p.oneOfType([p.number, p.string]).isRequired,
    type: p.string.isRequired,
    title: p.string,
    overlay: p.string,
    description: p.string,
    metricUnits: p.bool, // the bool types here are throwing out warnings when we populate them with urlbar
    sampleGraph: p.bool,
    brandedLogoPath: p.string,
    privacyCode: p.string,
    hideDownload: p.bool,
    hideStats: p.bool,
    hideFullLink: p.bool,
    showPhotos: p.bool,
    hot: p.string
  }

  static defaultProps = {
    overlay: 'rwgps'
  }

  constructor (props) {
    super(props)
    this.state = { troute: null, showMap: false }
  }

  showMapWhenContainerHasHeight = () => {
    if (this._ref.clientHeight > 0) {
      this.setState({ showMap: true })
      window.removeEventListener('resize', this.showMapWhenContainerHasHeight)
    }
  }

  componentDidMount () {
    this.fetchData()

    // if an ancestor to the iframe is set to display:none, the map will improperly calculate viewport
    // bounds if it is rendered prior to being visible (and having a size)
    if (this._ref.clientHeight === 0) {
      window.addEventListener('resize', this.showMapWhenContainerHasHeight)
    } else {
      this.setState({ showMap: true })
    }
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.showMapWhenContainerHasHeight)
  }

  fetchData = () => {
    const { id, type, privacyCode } = this.props

    const url = privacyCode
      ? `/${type}s/${id}.json?privacy_code=${privacyCode}&apikey=x&version=2`
      : `/${type}s/${id}.json?apikey=x&version=2`

    fetchJSON(url)
      .then(res => {
        console.log('fetchData')
        this.setState({ troute: type === 'trip'
          ? deserializeTrip(res.trip)
          : deserializeRoute(res.route)
        })
      })
      .catch(e => {
        console.error(e)
      })
  }

  url = (path = '') => {
    const { type, privacyCode, id } = this.props
    return privacyCode
      ? `/${type}s/${id}${path}?privacy_code=${privacyCode}`
      : `/${type}s/${id}${path}`
  }

  render () {
    const { title, type, overlay, sampleGraph, metricUnits, hideDownload, hideStats, hideFullLink, showPhotos, brandedLogoPath } = this.props
    const { troute, showMap } = this.state

    const links = (
      <ul className={styles.linkBar}>
        {!hideFullLink &&
          <li><a href={this.url()} target='_blank' title={`View this ${type} on Ride with GPS`}>
            View Full Version
          </a></li>}
        {!hideDownload && type === 'route' && <li><a href={this.url('/send_to_device')} target='_blank' title={`Sync this route to your phone or GPS`}>
          Send to Device
        </a></li>}
        {!hideStats &&
          <li className={styles.collapses}>
            {troute && formatDistance(troute.distance, { metricUnits }).toString({ short: true })}
          </li>}
        {!hideStats &&
          <li className={styles.collapses}>
            +{troute && formatDistance(troute.elevationGain, { units: metricUnits ? 'meters' : 'feet' }).toString({ short: true })}
            {' / '}
            -{troute && formatDistance(troute.elevationLoss, { units: metricUnits ? 'meters' : 'feet' }).toString({ short: true })}
          </li>}
      </ul>
    )

    // plan here is to stop using TitleBar (scope it to the MRE instead)
    return (
      <div className={cx(styles.TripRouteEmbed, embedStyles.Embed)} ref={el => { this._ref = el }}>
        <TitleBar
          eventUrl={!hideFullLink && this.url()}
          heading={title || (troute && troute.name)}
          subHeading={links}
          brandedLogoPath={brandedLogoPath} />
        {troute && showMap && <Map experimental
          defaultOverlay={overlay}
          routes={[troute]}
          sampleGraph={!!sampleGraph}
          metricUnits={metricUnits}
          mapSettings={{ scrollWheelZoom: false, showPOIs: true }}
          height='calc(100% - 55px)'>
          {showPhotos && <PhotoClusters troute={troute} clusterStrategy='trip' />}
        </Map>}
        {brandedLogoPath && poweredBy(!!sampleGraph)}
      </div>
    )
  }
}

const poweredBy = (sampleGraph) => <div className={cx(styles.poweredBy, sampleGraph && styles.poweredBySG)}>
  <a target='_blank' href='https://ridewithgps.com'>
    <span>Powered by </span><img src='/images/logos/horizontal-logo-white.svg' width={94} height={22} />
  </a>
</div>
